import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as routes from "../../shared/routes";
import * as loginActions from "../../login/loginActions";

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.logoutConfirmDialog = React.createRef();
    this.searchConfirmDialog = React.createRef();
  }

  state = {
    collapsed: true
  };

  componentDidUpdate() {
    if (this.logoutConfirmDialog.current) {
      this.logoutConfirmDialog.current.addEventListener('close', (e) => {
        if (e.detail.value) {
          this.handleLogoutYesNoClick(e)
        }
      })
    }

    if (this.searchConfirmDialog.current) {
      this.searchConfirmDialog.current.addEventListener('close', (e) => {
        if (e.detail.value) {
          this.handleSearchYesNoClick(e)
        }
      })
    }
  }

  componentWillUnmount() {
    if (this.logoutConfirmDialog.current) {
      this.logoutConfirmDialog.current.removeEventListener("close", this);
    }

    if (this.searchConfirmDialog.current) {
      this.searchConfirmDialog.current.removeEventListener("close", this);
    }
  }

  toggleNavbar = () => {
    this.setState(prevState => ({
      collapsed: !prevState.collapsed
    }));
  };

  handleLogoutYesNoClick(e) {
    if (e.detail.value) {
      this.props.history.push(routes.login);
    }
  }

  handleSearchYesNoClick(e) {
    if (e.detail.value) {
      this.props.history.push(routes.caseSearch)
    }
  }

  navItemClickHandler = (route) => {
    this.props.history.push(route);
  };

  logoutHandler = () => {
    if (this.props.isFieldChanged) {
      this.logoutConfirmDialog.current.show()
    }
    else {
      this.props.onLogout()
    }
  }

  searchHandler = () => {
    if (this.props.isFieldChanged) {
      this.searchConfirmDialog.current.show()
    }
    else {
      this.props.history.push(routes.caseSearch)
    }
  }

  hasMatterContext() {
    return this.props.matterReference !== "";
  }

  logout = event => {
    event.preventDefault();

    this.props.onLogout();

    this.props.history.push(routes.login);
  };

  render() {

    if (!this.props.token) {
      return null
    }

    return (
      <mosaic-navbar fixed-top collapse>
        <mosaic-navbar-brand></mosaic-navbar-brand>
        <mosaic-navbar-collapse-toggle></mosaic-navbar-collapse-toggle>
        <mosaic-navbar-collapse>
          <mosaic-navbar-navigation>
            <mosaic-navbar-nav-item>
              <a href="#" onClick={() => this.searchHandler()}>
                <mosaic-icon name="search"></mosaic-icon>
                <div>Search</div>
              </a>
            </mosaic-navbar-nav-item>
            <mosaic-navbar-nav-item>
              <a href="#" onClick={() => this.logoutHandler()}>
                <mosaic-icon name="user"></mosaic-icon>
                <div>Log Out</div>
              </a>
            </mosaic-navbar-nav-item>
          </mosaic-navbar-navigation>
        </mosaic-navbar-collapse>
        <mosaic-dialog
          color="warning"
          header-title="Confirm"
          id="confirm-dialog"
          dismiss-text="No"
          confirm-text="Yes"
          ref={this.logoutConfirmDialog}
        >
          <mosaic-icon
            name="error"
            width="48"
            height="48"
            class="m-1 mr-2 float-left fill-warning"
          />
          <p className="pt-3 p">Are you sure you want to logout without saving?</p>
        </mosaic-dialog>
        <mosaic-dialog
          color="warning"
          header-title="Confirm"
          id="confirm-dialog"
          dismiss-text="No"
          confirm-text="Yes"
          ref={this.searchConfirmDialog}
        >
          <mosaic-icon
            name="error"
            width="48"
            height="48"
            class="m-1 mr-2 float-left fill-warning"
          />
          <p className="pt-3 p">Are you sure you want to discard your changes?</p>
        </mosaic-dialog>
      </mosaic-navbar>
    );
  }
}

const mapStateToProps = state => ({
  matterReference: state.matter.reference,
  routing: state.routing,
  token: state.login.token,
  isFieldChanged: state.clientDataCollect.isFieldsChanged
});

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => dispatch(loginActions.logout())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Navigation)
);
